export const API_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://flexit-backend.herokuapp.com/'
    : null;

export const AUTH0_DOMAIN = 'https://dev--buir51f.us.auth0.com'
export const AUTH0_CLIENT_ID = 'Zx0ycjN29L7A9zGfwHAHlPCqrzU7Gvlm'
export const AUTH0_AUDIENCE = 'flexit-backend'
